import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';
import { Grid, Typography, Box, makeStyles } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';

import { AreaText } from '../../../../Common/UI/AreaText';
import { useState } from 'react';

const areaUnitLabels = {
    'ha': 'ha',
    'm2': 'm²',
    'km2': 'km²',
    'ac': 'ac',
    'sqft': 'sqft'
};

const useStyles = makeStyles((theme) => styles(theme));

const propTypes = {
    value: PropTypes.number,
    label: PropTypes.string,
    defaultAreaUnit: PropTypes.oneOf(['ha', 'm2', 'ac', 'sqft']),
    areaUnits: PropTypes.array,
    labelProps: PropTypes.object
};

const defaultProps = {
    value: undefined,
    label: 'Area',
    defaultAreaUnit: 'ha',
    areaUnits: ['ha', 'km2', 'ac'],
    labelProps: {}
};

function DrawnAreaInfoCard ({ value, label, defaultAreaUnit, areaUnits, labelProps }) {
    const classes = useStyles();

    const [areaUnit, setAreaUnit] = useState(defaultAreaUnit)
  
    function handleAreaUnitChange (event, newAreaUnit) {
        if (newAreaUnit) {
            setAreaUnit(newAreaUnit);
        }
    }
        
    return (
        <Grid container spacing={2} alignContent='center' alignItems='center'>
            <Grid item xs={4} className={classes.gridCell}>
                <Typography
                    component="div"
                    {...labelProps}
                >
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={5} className={classes.gridCell}>
                <Typography 
                    className={classes.areaValue}
                >
                    {
                        value ? 
                            <AreaText
                                area={value}
                                unit={areaUnit}
                            /> : 
                            'N/A'
                    }
                </Typography>
            </Grid>
            <Grid item xs={3}>
                <ToggleButtonGroup
                    classes={{
                        root: classes.toggleButtonGroup
                        // grouped: classes.toggleButton
                    }}
                    value={areaUnit}
                    exclusive
                    onChange={handleAreaUnitChange}
                    size='large'
                >
                    {
                        areaUnits.map(au =>
                            (
                                <ToggleButton 
                                    key={au} 
                                    classes={{
                                        root: classes.toggleButtonRoot,
                                        selected: classes.toggleButtonSelected
                                    }}
                                    value={au}
                                >
                                    {areaUnitLabels[au]}
                                </ToggleButton>
                            )
                        )
                    }
                </ToggleButtonGroup>
            </Grid>
        </Grid>
    );
}

const styles = theme => ({
    toggleButtonGroup: {
        backgroundColor: 'initial',
        height: '40px',
        width: '100%'
    },
    toggleButtonRoot: {
        height: '40px',
        flex: '1 0 33.33%',
        fontSize: '15px',
        padding: '0 5px',
        textTransform: 'initial',
        borderColor: theme.palette.background.border,
        color: theme.palette.text.secondary
    },
    toggleButtonSelected: {
        backgroundColor: `${theme.palette.background.border} !important`,
        color: `${theme.palette.text.primary} !important`
    },
    gridCell: {
        justifyContent: 'space-between',
        color: theme.palette.text.primary,
        display: 'flex',
        alignItems: 'center',
        padding: '6px 5px !important'
    },
    areaValue:{
        paddingLeft: 16
    }
});

DrawnAreaInfoCard.propTypes = propTypes;
DrawnAreaInfoCard.defaultProps = defaultProps;

export default DrawnAreaInfoCard;